/**
 * Normalises markdown before handing it to ReactMarkdown.
 *
 * Currently strips blank lines that appear inside bullet lists, since the
 * upstream model occasionally emits them and they break list grouping.
 */
export const preprocessMarkdown = (content) => {
  return content.replace(/\n\s*\n-/g, "\n-");
};
